import Axios from "axios";
import { errorResponse } from "../../../../utils/apiHelpers/apiHelpers";
import { appConfigs } from "../../../../utils/configurations";

export function getUserGuide() {
    
    return async (dispatch: any) => {
        Axios.get(
            appConfigs.server.URL + "/ui/api/get_tutorials"
        )
        .then(response => { 
                dispatch({ type: "USERGUIDE_GET_SUCCESS", data: response.data.data.tutorials });
                console.log(response.data.data.tutorials);
            }
        )
        .catch(function (error) {
            console.log(`error`, error)
        });
    };
}


export function userguideSetSearch(
    searchText: string 
) {
    return (dispatch: any) => {
        dispatch({ type: "USERGUIDE_SET_SEARCH", searchText: searchText });
    }
}  

export function setTab(
    tabNumber: string 
) {
    return (dispatch: any) => {
        dispatch({ type: "SET_TAB", tabNumber: tabNumber });
    }
}   
